import 'babel-polyfill'
import 'whatwg-fetch'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import miniToastr from 'mini-toastr' // https://github.com/se-panfilov/mini-toastr
import VueI18n from 'vue-i18n'
import Vuelidate from 'vuelidate'
import VueMoment from 'vue-moment'
import VueNotifications from 'vue-notifications'
import App from './App'
import messages from './i18n/messages'
import router from './router'
import store from './store'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'ti-icons/css/themify-icons.css'

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}

Vue.use(BootstrapVue)
Vue.use(VueI18n)
Vue.use(Vuelidate)
Vue.use(VueMoment)
Vue.use(VueNotifications, options)
Vue.config.productionTip = false

const i18n = new VueI18n({
  locale: 'de', // set locale
  messages      // set locale messages
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js